<template>
  <div id="user-list">
    <v-card>
      <v-card-title> {{ $t("Tapahtumat") }} </v-card-title>
      <!-- actions -->

      <v-card-text class="d-flex align-center flex-wrap pb-0">
        <v-spacer></v-spacer>

        <div class="d-flex align-center flex-wrap">
          <v-btn color="primary" class="mb-4" :to="{ name: 'admin-event-form' }">
            <span>{{ $t("Uusi tapahtuma") }}</span>
          </v-btn>
        </div>
      </v-card-text>
      <v-data-table :headers="tableColumns" :items="events" :server-items-length="totalCount" :items-per-page="10"
        :options.sync="options" :loading="loading" mobile-breakpoint="0" :footer-props="{
          'items-per-page-options': [10],
        }">
        <!-- title -->
        <template #[`item.title`]="{ item }">
          <div class="d-flex align-center">
            <router-link :to="{ name: 'admin-event-form', params: { id: item.id } }"
              class="font-weight-medium text-decoration-none">
              {{ item.title }}
            </router-link>
          </div>
        </template>

        <!-- group -->
        <template #[`item.group_name`]="{ item }">
          <v-chip label small color="primary">{{ item.group_name }}</v-chip>
        </template>

        <!-- group -->
        <template #[`item.time`]="{ item }">
          <span>{{ getDateTime(item.time) }} </span>
        </template>

        <!-- published -->
        <template #[`item.published`]="{ item }">
          <div class="d-flex text-center">
            <v-icon v-if="item.published" size="24" :color="getPublishedColor(item)">{{ icons.mdiCheckboxMarkedCircle }}
            </v-icon>
            <v-icon v-else size="24" color="error">{{ icons.mdiCloseCircle }}
            </v-icon>
          </div>
        </template>

        <!-- publish date -->
        <template #[`item.publish_date`]="{ item }">
          <span>{{ item.release_date }}</span>
        </template>

        <!-- polls replioes -->
        <template #[`item.enrollments`]="{ item }">
          <router-link v-if="item.enrollment" :to="{ name: 'admin-event-enrollments', params: { id: item.id } }"
            class="font-weight-medium text-decoration-none">
            {{ $t("Ilmoittautumiset") }} &raquo;
          </router-link>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>


<script>
import { onMounted, ref, watch } from "@vue/composition-api";
import adminApi from "@/api/admin";
import { mdiCheckboxMarkedCircle, mdiCloseCircle, mdiPlus } from "@mdi/js";
import { useTranslations } from "@core/libs/i18n";
import { getDateTime } from "@/@core/utils/datetime_helpers";
import moment from "moment";

export default {
  setup() {
    const events = ref([]);
    const totalCount = ref(0);

    const page = ref(1);
    const options = ref({});
    const loading = ref(false);

    const { t } = useTranslations();

    const tableColumns = [
      { text: t("Otsikko").toUpperCase(), value: "title", sortable: false },
      { text: t("Aika").toUpperCase(), value: "time", sortable: false },
      { text: t("Ryhmä").toUpperCase(), value: "group_name", sortable: false },
      {
        text: t("Julkaistu").toUpperCase(),
        value: "published",
        sortable: false,
      },
      {
        text: "",
        value: "enrollments",
        sortable: false,
      },
    ];

    // fetch data
    const fetchEvents = async () => {
      loading.value = true;
      const response = await adminApi.getEvents(page.value);

      events.value = response.data.results;
      totalCount.value = response.data.count;

      loading.value = false;
    };

    const getPublishedColor = (eve) => {
      if (eve.release_date) {

        if (moment(new Date()).isAfter(eve.release_date))
          return 'success';
        return 'warning';
      }
      return 'success';
    }

    watch(options, () => {
      page.value = options.value.page;
      fetchEvents();
    });

    // UnRegister on leave
    onMounted(() => {
      // fetchEvents();
    });

    return {
      events,
      totalCount,
      tableColumns,
      options,
      loading,
      getPublishedColor,
      getDateTime,
      icons: {
        mdiCheckboxMarkedCircle,
        mdiCloseCircle,
        mdiPlus,
      },
    };
  },
};
</script>

<style></style>
